var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verify-email-page"},[_c('HollowDotsSpinner',{attrs:{"animation-duration":1000,"dot-size":12,"dots-num":3,"color":'#95a5a6'}}),_vm._v(" "),_c('div',{staticClass:"verify-email-page__message"},[_vm._v("\n    "+_vm._s(_vm.$t('AUTH.VERIFY_EMAIL.VERIFYING_MESSAGE'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }